import { app } from '../../../../../bootstrap/core';
import { successfulSubmitState } from './successfulSubmit.state';
import { successfulSubmitComponent } from './successfulSubmit.component';

app.config(successfulSubmitState);
app.component(successfulSubmitComponent.name, successfulSubmitComponent);
